import React, { useCallback, useEffect, useState } from 'react';
import { FlexWrapper, HighlightText, PaginationBox, ViewIconBox } from '../../theme/common_style';
import { Badge, Button, Pagination, Table } from 'antd';
import { FilterIconNew, NoLeaveIcon, ViewIconNew } from '../../theme/SvgIcons';
import SearchField from '../../components/searchField/SearchField';
import { useNavigate } from 'react-router-dom';
import EmptyData from '../../components/common/EmptyData';
import { useSelector } from 'react-redux';
import { GetLeaveRequests } from '../../redux/lms/apiRoute';
import { toast } from 'react-toastify';
import {
  checkPermission,
  convertToLocalDate,
  convertToLocalTime,
  debounce,
  generateEmployeeImgUrl,
  getCategory,
  getFullName,
  getSlot,
  getStatusTag,
  useWindowWide
} from '../../utils/common_functions';
import RequestFilter from './RequestFilter';
import { StickyBox } from '../../utils/style';
import { actionTypeEnums, apiModules } from '../../utils/constant';
import { useTheme } from '@emotion/react';
import { AvatarGroup } from '../../components/common/AvatarGroup';
import styled from '@emotion/styled';

const Requests = () => {
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(10);
  const [loading, setLoading] = useState(true);
  const [apiData, setApiData] = useState();
  const [limit, setLimit] = useState(20);
  const [search, setSearch] = useState('');
  const largeScreen = useWindowWide(1085);
  const [filterDrawer, setFilterDrawer] = useState(false);
  const [filterData, setFilterData] = useState({});
  const activeTab = useSelector((state) => state.RequestSlice.RequestTab);
  const [sort, setSort] = useState({});
  const navigate = useNavigate();
  const { data, isEmployee } = useSelector((e) => e.userInfo);
  const theme = useTheme();
  const { READ } = actionTypeEnums;
  const { EMPLOYEE } = apiModules;
  const { permissions } = data;

  const canReadEmp = checkPermission(EMPLOYEE, READ, permissions);

  const fetchData = async (search) => {
    const params = new URLSearchParams();
    params.append('employee_id', data?.user_details?.id);
    params.append('page', page);
    params.append('limit', limit);
    // params.append('filter', activeTab);
    sort?.sortBy && params.append('sort_by', sort?.sortBy);
    sort?.orderBy && params.append('sort_order', sort?.orderBy);
    search && params.append('search', search);
    if (Object.keys(filterData || {}).length > 0) {
      Object.entries(filterData).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, value);
        }
      });
    }
    if (filterData?.start_date) {
      params.append('end_date', filterData?.start_date);
    }
    setLoading(true);
    try {
      const res = await GetLeaveRequests(params);
      if (res?.statusCode === 200) {
        setApiData(res?.data?.leaves);
        setTotal(res?.data?.total);
      } else toast.error(res?.message || 'Something went wrong');
    } catch (error) {
      toast.error(error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const handleSorting = (val) => {
    if (val?.field) {
      let order = val?.order == 'ascend' ? 'ASC' : 'DESC';
      setSort({ sortBy: val?.columnKey, orderBy: order, ...val });
    }
    setPage(page);
    setLimit(20);
  };

  const columns = [
    {
      width: 180,
      title: 'Emp Name',
      dataIndex: 'employee',
      key: 'employee_name',
      sorter: true,
      render: (employee) => {
        const emp = [
          {
            name: getFullName(employee?.first_name, employee?.middle_name, employee?.last_name),
            src: generateEmployeeImgUrl(employee?.id),
            id: employee?.id
          }
        ];
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
            <AvatarGroup avatars={emp} />
            {!isEmployee && canReadEmp ? (
              <HighlightText
                onClick={() =>
                  navigate(`/view-employee`, {
                    state: {
                      id: employee?.id,
                      name: emp[0]?.name
                    }
                  })
                }>
                {employee?.first_name}
              </HighlightText>
            ) : (
              <span>{employee?.first_name}</span>
            )}
          </FlexWrapper>
        );
      }
    },
    {
      width: 120,
      title: 'Emp Code',
      dataIndex: 'emp_code',
      key: 'emp_code',
      sorter: true,
      render: (_, record) => {
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
            <span>{record?.employee?.emp_code}</span>
          </FlexWrapper>
        );
      }
    },
    {
      width: 120,
      title: 'Leave Type',
      dataIndex: 'leave_type',
      key: 'leave_type',
      render: (leave_type) => {
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
            <span>{leave_type}</span>
          </FlexWrapper>
        );
      }
    },
    {
      width: 130,
      title: 'Applied On',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (created_at) => {
        return (
          <FlexWrapper style={{ textAlign: 'center' }}>
            {convertToLocalTime(created_at)}
          </FlexWrapper>
        );
      }
    },
    {
      width: 130,
      title: 'Start Date',
      dataIndex: 'start_date',
      key: 'start_date',
      sorter: true,
      render: (startDate) => {
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
            {convertToLocalDate(startDate)}
          </FlexWrapper>
        );
      }
    },
    {
      width: 130,
      title: 'End Date',
      dataIndex: 'end_date',
      key: 'end_date',
      sorter: true,
      render: (endDate) => {
        return (
          <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
            {convertToLocalDate(endDate)}
          </FlexWrapper>
        );
      }
    },
    {
      width: 120,
      title: 'No of Leaves',
      dataIndex: 'no_of_leaves',
      key: 'no_of_leaves',
      render: (no_of_leaves) => (
        <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor="default">
          <span>{no_of_leaves || 'N/A'}</span>
        </FlexWrapper>
      )
    },
    {
      width: 140,
      title: 'Leave Category',
      dataIndex: 'leave_category',
      key: 'leave_category',
      render: (leave_category) => getCategory(leave_category) ?? 'N/A'
    },
    {
      width: 120,
      title: 'Leave Slot',
      dataIndex: 'leave_slot',
      key: 'leave_slot',
      render: (leave_slot) => getSlot(leave_slot) ?? 'N/A'
    },
    {
      title: 'Status',
      dataIndex: 'leave_status',
      key: 'leave_status',
      fixed: 'right',
      width: 110,
      render: (status) => getStatusTag(status)
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      fixed: 'right',
      className: 'action-column',
      width: 70,
      render: (_, data) => {
        return (
          <ViewIconBox
            onClick={() => {
              navigate(`/requests/details`, {
                state: { lms: data }
              });
            }}
            cursor="pointer">
            <ViewIconNew />
          </ViewIconBox>
        );
      }
    }
  ];

  const optimizedFn = useCallback(debounce(fetchData), [data, activeTab, page, filterData, sort]);

  useEffect(() => {
    if (search !== null) {
      optimizedFn(search);
    } else {
      fetchData();
    }
  }, [data, search, activeTab, page, filterData, sort]);

  return (
    <div>
      {filterDrawer && (
        <RequestFilter
          open={filterDrawer}
          onClose={() => setFilterDrawer(false)}
          filterData={filterData}
          setFilterData={setFilterData}
          setPage={setPage}
        />
      )}
      <StickyBox padding="8px 0">
        <FlexWrapper
          width={'100%'}
          justify={largeScreen ? 'end' : 'start'}
          gap="16px"
          cursor="default"
          style={{
            marginBottom: '16px'
          }}>
          {/* <Segmented
            value={activeTab}
            prefixCls="antCustomSegmented"
            options={LeaveTabOptions}
            onChange={(value) => {
              dispatch(updateRequestTab(value));
              setPage(1);
            }}
          /> */}

          <FlexWrapperLeave justify={'end'} gap="6px" cursor="default">
            <SearchField
              placeholder="Search by Leave type..."
              width={'250px'}
              value={search}
              onChange={(val) => {
                setSearch(val);
                setPage(1);
              }}
            />
            <Badge
              count={Object?.values(filterData || {})?.reduce(
                (acc, item) => acc + (item ? 1 : 0),
                0
              )}
              color={theme.primaryColor}
              offset={[-9, 4]}
              prefixCls="filterBadge">
              <Button prefixCls="custom-filter-btn" onClick={() => setFilterDrawer(true)}>
                <FilterIconNew /> Filter
              </Button>
            </Badge>
          </FlexWrapperLeave>
        </FlexWrapper>
      </StickyBox>
      {loading || apiData?.length > 0 ? (
        <>
          <Table
            prefixCls="antCustomTable"
            scroll={{ x: '100%' }}
            columns={columns}
            dataSource={apiData}
            pagination={false}
            loading={loading}
            onChange={(newPagination, filters, sorter) => {
              if (!sorter.order) {
                setSort({});
              } else {
                handleSorting(sorter);
              }
            }}
            defaultSortOrder={sort.order}
          />
          {total > limit && (
            <PaginationBox>
              <Pagination
                current={page}
                prefixCls="custom-pagination"
                pageSize={limit}
                total={total}
                onChange={(e) => setPage(e)}
                showSizeChanger={false}
              />
            </PaginationBox>
          )}
        </>
      ) : (
        <EmptyData
          height={'50vh'}
          icon={<NoLeaveIcon />}
          title={'No Leave Requests'}
          subTitle={'There are no leave requested.'}
        />
      )}
    </div>
  );
};

export default Requests;

const FlexWrapperLeave = styled.div`
  display: flex;
  justify-content: ${({ justify }) => justify || 'flex-start'};
  gap: ${({ gap }) => gap || '10px'};
  align-items: center;
  cursor: ${({ cursor }) => cursor || 'default'};
  flex-wrap: wrap;

  /* Desktop */
  @media (min-width: 1025px) {
    flex-direction: row;
    justify-content: ${({ justify }) => justify || 'flex-end'};
  }

  /* Tablet */
  @media (max-width: 1024px) and (min-width: 768px) {
    flex-direction: row;
    gap: 8px;
  }

  /* Mobile */
  @media (max-width: 767px) {
    width: 100%;
    display: grid;
    grid-template-columns: 70% 30%;

    button,
    input {
      width: 100%; /* Make buttons and search field full width */
    }
  }
`;
